import * as components from './components';

export default { components };



// WEBPACK FOOTER //
// ./src/modules/settings/index.js